import axios from 'axios'

export default {
  fetch (method, url, data) {
    return new Promise(function (resolve, reject) {
      if (method === 'get') {
        resolve(axios.get(url, data))
      } else if (method === 'post') {
        resolve(axios.post(url, data))
      }
    })
  }
  // fetches (method, url, data, store, next) {
  //   return new Promise(function (resolve, reject) {
  //     axios.post(url, data).then(res => {
  //       if (getCookie('logoimgurl')) {
  //         store.state.logoimgurl = decodeURIComponent(getCookie('logoimgurl'))
  //       } else {
  //         setCookie('logoimgurl', res.data.logoimgurl);
  //       }
  //       if (getCookie('allreqdomain')) {
  //         store.state.allreqdomain = getCookie('allreqdomain')
  //       } else {
  //         setCookie('allreqdomain', res.data.allreqdomain);
  //       }
  //       resolve()
  //     }, error => {
  //       reject(error)
  //     })
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/apis/index.js